export default __webpack_public_path__ + "static/media/profile.65f9347f.png";